var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChemicalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_126",
    "data-name": "Group 126",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 140,
    height: 140,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M70,0A70,70,0,1,1,0,70,70,70,0,0,1,70,0",
    fill: "#1a1818",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M55.833,80.222A24.2,24.2,0,0,1,54.268,83.2c-.558.967-1.028,1.993-1.587,2.955-.54.931-1.108,1.886-1.62,2.92-1.186,2.4-3.522,6.253-4.835,8.791-.864,1.671-2.966,5-2.966,6.292H95.648c0-1.436-3.131-6.557-4.076-8.327l-4.424-7.979c-1.479-2.756-2.852-5.3-4.367-8.035l-3.366-6.068a15.591,15.591,0,0,1-1.056-2.09,10.959,10.959,0,0,0-2.726,1.467c-.487.325-.759.516-1.219.877-.509.4-.679.681-1.192,1.078-1.889,1.456-3.711,4.751-6.615,6.136-2.933,1.4-8.11-.375-10.774-1",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M51.293,48.772v3.843a5.255,5.255,0,0,0,4.714,4.718h.874V65.72a25.126,25.126,0,0,1-2.04,4.249c-.322.575-.5.824-.812,1.458-1.132,2.305-5.03,9.429-6.11,11.36l-5.243,9.78c-.292.574-.462.97-.779,1.491-.3.491-.486.868-.731,1.366-.282.57-.511.886-.817,1.454-.28.522-.426.87-.695,1.4-1.047,2.063-3.049,5.111-1.606,8.3a5.885,5.885,0,0,0,5.562,3.171H95.473c3.456,0,6.985-2.552,6.985-5.94,0-2.7-.767-3.718-2.021-5.841-3.958-6.694-7.943-14.005-11.918-20.575-.487-.805-.834-1.5-1.327-2.34-.526-.9-5.165-8.479-5.165-9.334V57.333H82.9a5.255,5.255,0,0,0,4.715-4.718V48.772A5.254,5.254,0,0,0,82.9,44.054H56.007a5.254,5.254,0,0,0-4.714,4.718m2.794,2.8c0-2.318-.325-4.717,2.969-4.717h24.8c3.294,0,2.969,2.4,2.969,4.717,0,3.477-2.7,2.97-5.588,2.97V66.768c0,.594,3.551,6.956,4.183,8.045l1.87,3.546c.435.88.786,1.382,1.223,2.271,1.348,2.748,3.588,6.447,4.946,9.2,1.343,2.723,3.618,6.488,4.949,9.2,1,2.028,4.974,7.921-1.979,7.921H45.007c-7.32,0-4.019-4.845-2.619-7.687.788-1.6,1.686-3.01,2.5-4.662.438-.885.789-1.39,1.223-2.27l3.726-6.929c.441-.884.8-1.426,1.224-2.272.44-.885.8-1.426,1.222-2.271.442-.884.775-1.443,1.22-2.273.238-.44.374-.771.58-1.168.244-.47.458-.746.7-1.218.272-.523,4.887-9.042,4.887-9.262V54.537c-2.891,0-5.588.507-5.588-2.97",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M64.04,55.76a5.972,5.972,0,0,0,5.788,6.1,5.842,5.842,0,0,0,5.278-3.235,6.04,6.04,0,0,0-1.065-6.927,5.921,5.921,0,0,0-10,4.067",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M63.342,69.039c0,4.556,6.421,5.789,8.142,1.682a4.522,4.522,0,0,0-.862-4.774,5.558,5.558,0,0,0-2.049-1.1,4.219,4.219,0,0,0-5.231,4.189",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M65.262,41.084a3.335,3.335,0,1,0-3.1-3.462,3.36,3.36,0,0,0,3.1,3.462",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M70.327,32.871a2.851,2.851,0,1,0,2.62-2.62,2.958,2.958,0,0,0-2.62,2.62",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemicalIcon);
export default __webpack_public_path__ + "static/media/chemical-icon.ec296b3bdb60c160e7b3a017480e9482.svg";
export { ForwardRef as ReactComponent };